'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var makeStyles = require('../../../../node_modules/@material-ui/core/esm/styles/makeStyles.js');

var BAR_BORDER_RADIUS = 10;
var CONTAINER_HEIGHT = 14;
var useStyles = makeStyles(function (theme) {
  return {
    linearProgress: {
      height: '100%',
      borderRadius: BAR_BORDER_RADIUS
    },
    grayBar: {
      animation: 'unset',
      background: theme.palette.grey[200],
      borderRadius: BAR_BORDER_RADIUS
    },
    container: {
      width: '100%',
      backgroundColor: theme.palette.grey[200],
      position: 'relative',
      height: CONTAINER_HEIGHT,
      borderRadius: BAR_BORDER_RADIUS
    },
    primaryBar: function primaryBar(_ref) {
      var _ref$primaryBarColor = _ref.primaryBarColor,
          primaryBarColor = _ref$primaryBarColor === void 0 ? theme.palette.primary.main : _ref$primaryBarColor;
      return {
        backgroundColor: primaryBarColor,
        borderRadius: BAR_BORDER_RADIUS
      };
    },
    secondaryBar: function secondaryBar(_ref2) {
      var _ref2$secondaryBarCol = _ref2.secondaryBarColor,
          secondaryBarColor = _ref2$secondaryBarCol === void 0 ? theme.palette.grey[400] : _ref2$secondaryBarCol;
      return {
        backgroundColor: secondaryBarColor,
        borderRadius: BAR_BORDER_RADIUS
      };
    }
  };
});

exports.useStyles = useStyles;
